import type { CustomizationController } from "@rebasepro/cms-types";
import { useContext } from "react";
import { CustomizationControllerContext } from "../contexts/CustomizationControllerContext";

/**
 * Use this hook to retrieve the customization controller.
 * This hook includes all the customization options that can be used
 * to customize the admin.
 *
 * You will likely not need to use this hook directly.
 *
 * @group Hooks and utilities
 */
export const useCustomizationController = (): CustomizationController => {
    const controller = useContext(CustomizationControllerContext);
    if (!controller) throw new Error("useCustomizationController must be used inside <Rebase>");
    return controller;
};
